import { useState } from "react";

// Renders a team's real logo, gracefully falling back to the colored initials
// badge when no logo URL is provided or the image fails to load.
export default function TeamLogo({ abbr, logo, color = "#0A84FF", size = 36, rounded = "rounded", className = "" }) {
  const [failed, setFailed] = useState(false);
  const dim = { width: size, height: size };

  if (logo && !failed) {
    return (
      <img
        src={logo}
        alt={abbr}
        loading="lazy"
        onError={() => setFailed(true)}
        style={{ ...dim, padding: Math.max(2, Math.round(size * 0.1)) }}
        className={`${rounded} object-contain shrink-0 bg-white/90 ${className}`}
        data-testid={`team-logo-${abbr}`}
      />
    );
  }

  const hex = (color || "").replace("#", "");
  const lum = hex.length === 6 ? 0.299 * parseInt(hex.slice(0, 2), 16) + 0.587 * parseInt(hex.slice(2, 4), 16) + 0.114 * parseInt(hex.slice(4, 6), 16) : 255;
  const textColor = lum < 90 ? "rgba(255,255,255,0.85)" : color;
  return (
    <div
      style={{ ...dim, backgroundColor: `${color}33`, color: textColor, border: `1px solid ${lum < 90 ? "rgba(255,255,255,0.2)" : `${color}55`}`, fontSize: Math.round(size * 0.34) }}
      className={`${rounded} flex items-center justify-center font-display font-bold tracking-wide shrink-0 ${className}`}
      data-testid={`team-badge-${abbr}`}
    >
      {abbr}
    </div>
  );
}
